var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello",
    style: (_vm.currentQuestion.theme)
  }, [_c('Go', {
    staticClass: "hello__button",
    attrs: {
      "answer": _vm.answer,
      "choupi": _vm.currentQuestion.choupi
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick($event)
      }
    }
  }), _vm._v(" "), (this.currentQuestion.count) ? _c('Counter', {
    staticClass: "hello__counter"
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da055350","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Hello.vue
// module id = HI7M
// module chunks = 1